// extracted by mini-css-extract-plugin
export default {"classes":"Robotest_classes__lLw81","errorText":"Robotest_errorText__cim-O","btnDiv":"Robotest_btnDiv__v3bvi","bgGreen":"Robotest_bgGreen__bCsDs","bgRed":"Robotest_bgRed__KOdhu"};